var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.routeText
      ? _c("div", [_c("p", { domProps: { innerHTML: _vm._s(_vm.routeText) } })])
      : _c("div", [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("base.errors.unauthorized.message360")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("base-button", { on: { click: _vm.goToSignInOpensalud } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "base.errors.unauthorized-360-error-page.go-to-opensalud"
                    )
                  )
                )
              ])
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bd09c86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bd09c86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/errors/Unauthorized360AccessErrorPage.vue
// module id = 3625
// module chunks = 92